import { css } from '@emotion/core';
// import { typography, fontWeights } from '../../../../styles/typography';
// import { colorsPalette } from '../../../../styles/colors';
// import { MediaQueries } from '../../../../styles/Grid';
// import { errorCss } from '../../../ui/Form/baseStyles/index.styles';

export const formfield = css({
  '.inputfield': {
    marginBottom: '16px',
    background: '#ffffff',
    padding: '25px 16px 9px',
    paddingTop: '17px',
    borderRadius: '4px',
    border: '1px solid #d9dbdd',
    height: '56px',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '16px',

    div: {
      padding: '0',
      border: '0',
      width: '100%',
    },
  },
  '.date_field': {
    marginBottom: '16px',
    padding: '12px 16px',
    border: '1px solid #d9dbdd',
    borderRadius: '4px',
    height: '56px',
    display: 'flex',
    input: { border: '0px', input: { border: '0px', outline: '0px' } },
  },
});
